import React from 'react';
import styles from './Footer.module.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.Footer__Section}>
      <div className="container">
        <div className={styles.footGrid}>
          <div>
            <Link to="/" className={styles.wordmark}>
              FYNTIQ<span className={styles.dot} /><span className={styles.prod}>Business</span>
            </Link>
            <p className={styles.footTag}>
              The simplest way for small businesses to send invoices, accept every kind of payment, and reward customers.
            </p>
          </div>
          <div className={styles.footCol}>
            <h4>Product</h4>
            <Link to="/payments">Payments</Link>
            <Link to="/invoicing">Invoicing</Link>
            <Link to="/recurring-billing">Recurring billing</Link>
            <Link to="/protection">Chargeback Protection</Link>
            {/* <Link to="/chargelookup">Charge Lookup</Link> */}
          </div>
          <div className={styles.footCol}>
            <h4>Company</h4>
            <Link to="/pricing">Pricing</Link>
            <Link to="/payyitme">Fyntiq.Me Lynk</Link>
            <a href="https://wallet.fyntiq.com" target="_blank" rel="noopener noreferrer">Fyntiq Wallet</a>
          </div>
          <div className={styles.footCol}>
            <h4>Legal</h4>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/security">Security</Link>
          </div>
        </div>
        <div className={styles.footBottom}>
          <div className={styles.footLegal}>
            © {currentYear} Fyntiq Technologies LLC. Payment processing, settlement timing, financing, and chargeback protection are subject to eligibility and the terms of your merchant agreement.
          </div>
          <Link to={`${dashboardUrl}/signin`} className={styles.btnOutline}>Sign in</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
